export default function Services() {
  const services = [
    {
      icon: 'custom-highway',
      title: 'Highway Engineering and Adoption',
      description: 'Our highway engineering services provide technical design and advisory support for the delivery of adoptable highway infrastructure in accordance with local highway authority requirements.',
      features: ['Section 278 and Section 38 applications and technical approvals', 'Adoptable highway design', 'Vehicle swept path analysis', 'Highway adoption strategy', 'Highway layout and compliance reviews']
    },
    {
      icon: 'ri-drop-line',
      title: 'Drainage Engineering and Adoption',
      description: 'Our drainage engineering services provide compliant design and technical support for adoptable drainage infrastructure and regulatory approvals.',
      features: ['Section 104 104 and Section 106 applications and technical approvals', 'Ordinary Watercourse (OWC) consents', 'Sustainable Drainage Systems (SuDS) design', 'Maintenance manuals', 'Foul and surface water drainage strategies', 'Flood risk assessments (FRA)']
    },
    {
      icon: 'ri-home-4-line',
      title: 'Residential Infrastructure Engineering',
      description: 'Our estate engineering services provide detailed, compliant designs and supporting information for residential developments, ensuring buildability and long-term maintenance.',
      features: ['NHBC and Building Regulations compliant detailed residential parcel design', 'Construction information and specifications', 'Utility coordination and service corridor layouts', 'Site grading design and earthworks assessment']
    },
    {
      icon: 'ri-stack-line',
      title: 'Earthworks Assessment',
      description: 'Our earthworks services provide detailed analysis and strategies to optimise site grading, material use, and overall construction efficiency.',
      features: ['Earthworks assessments', 'Cut and fill analysis', 'Material quantity estimates', 'Site levels and grading strategies', 'Site preparation and earthworks plans']
    },
    {
      icon: 'ri-tools-line',
      title: 'Construction and Project Support Services',
      description: 'Our services provide practical support beyond design, assisting with the construction, verification, and handover of civil engineering infrastructure.',
      features: ['Preparation of conveyancing plans and documentation', 'Drainage verification and inspection post-construction', 'As-built record verification and compilation']
    },
    {
      icon: 'ri-search-line',
      title: 'Independent Technical Review',
      description: 'Our services provide impartial review and assessment of third-party civil engineering submissions, offering advice and recommendations to ensure compliance, buildability, cost efficiency, and alignment with client-specific requirements.',
      features: ['Review and verification of third-party designs and technical assessments across highways, drainage, earthworks, and infrastructure', 'Assessment against client-specific briefs, requirements, and project constraints', 'Identification of technical risks and recommendations for mitigation', 'Suggestions for value engineering to improve cost efficiency and constructability', 'Advice on alignment with planning conditions, adoption requirements, and regulatory approvals']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3">Our Civil Engineering Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Civil engineering design and advice focused on compliant, buildable solutions, with an emphasis on cost efficiency and regulatory compliance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-stone-50 rounded-xl p-8 hover:shadow-lg transition-shadow border border-stone-200">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                {service.icon === 'custom-highway' ? (
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {/* Road pattern \:/ */}
                    <path d="M4 24 L12 16" stroke="#10b981" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="16" cy="16" r="1.5" fill="#10b981"/>
                    <path d="M20 16 L28 24" stroke="#10b981" strokeWidth="2" strokeLinecap="round"/>
                    
                    {/* Car outline */}
                    <path d="M10 12 L12 10 L20 10 L22 12 L22 16 L10 16 Z" stroke="#10b981" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
                    <circle cx="13" cy="16" r="1.5" stroke="#10b981" strokeWidth="1.5" fill="none"/>
                    <circle cx="19" cy="16" r="1.5" stroke="#10b981" strokeWidth="1.5" fill="none"/>
                    <path d="M12 12 L12 10 M20 12 L20 10" stroke="#10b981" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                ) : (
                  <i className={`${service.icon} text-2xl text-emerald-600`}></i>
                )}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start text-sm text-gray-700">
                    <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
